export default __webpack_public_path__ + "static/media/document.f97e361a.svg";